import Crud from '../views/Finalizacao/Crud'
import Entity from '../views/Finalizacao/View'

let routes = {
    path: '/finalizacoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/finalizacoes/view/:id?',
            name: 'ViewFinalizacao',
            component: Entity,
            meta: {
                pageTitle: 'Visualizar Finalização',
                breadcrumb: [
                    {
                        text: 'Finalizações',
                        active: false,
                        to: '/finalizacoes',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/finalizacoes',
            name: 'list-finalizacoes',
            component: Crud,
            meta: {
                pageTitle: "Lista de Finalizações",
                breadcrumb: [
                    {
                        text: "Finalizações",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
